import React from 'react'
import { useTranslation } from 'react-i18next'

import Separator from '@/components-latest/primitives/Separator'
import Spinner from '@/components-latest/primitives/Spinner'
import type { CampaignItemDetail } from '@/ducks/campaigns/campaigns.types'

import CampaignDetailsItemRow from './CampaignDetailsItemRow'
import Styles from './CampaignDetailsModal.module.scss'

type Props = {
  item?: CampaignItemDetail
  isLoading?: boolean
}

const ItemDiscountDetails = ({ item, isLoading }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <Separator />
      <div className={Styles.section}>
        <h3 className={Styles.sectionTitle}>
          {t('marketing.campaigns.details.item-detail')}
        </h3>
        {isLoading ? (
          <div className={Styles.loadingRow}>
            <Spinner />
          </div>
        ) : (
          <CampaignDetailsItemRow item={item} />
        )}
      </div>
    </>
  )
}

export default ItemDiscountDetails
